<template>
  <footer>
    <div class="container">
      <div class="top-section footer-top">
        <div class="column footer-img">
          <router-link to="/">
            <img
              src="../../assets/images/footer-logo-skroutz-lm.svg"
              alt="skroutz last mile footer logo"
            />
          </router-link>
        </div>

        <div class="column">
          <i class="icon icon-info"></i>
          <div class="info-container">
            <h3>{{ $t('footer.infoColumn.usefulInfo') }}</h3>
            <span>
              {{ $t('footer.infoColumn.recipientKeepRights') }}
            </span>
            <router-link to="/xyk" class="page-link">
              {{ $t('footer.infoColumn.consumerObligationsMap') }}
            </router-link>
            <router-link to="/privacy" class="page-link">
              {{ $t('footer.infoColumn.privacyPolicy') }}
            </router-link>
            <router-link to="/cookies" class="page-link">
              {{ $t('footer.infoColumn.cookiesPolicy') }}
            </router-link>
            <router-link to="/complaintsReport" class="page-link">
              {{ $t('footer.infoColumn.issuesReport') }}
            </router-link>
            <span v-if="countryCode === 'GR'">
              {{ $t('footer.infoColumn.postalLicensesRegistryGR') }}
              <pre>{{ $t('footer.infoColumn.eettLicenseNumberGR') }}</pre>
            </span>
            <span v-if="countryCode === 'CY'">
              {{ $t('footer.infoColumn.postalLicensesRegistryCY') }}
              <pre>{{ $t('footer.infoColumn.getyLicenseNumberCY') }}</pre>
            </span>
          </div>
        </div>

        <div class="column">
          <i class="icon icon-support"></i>
          <div>
            <h3>{{ $t('footer.contactColumn.contactUs') }}</h3>
            <router-link to="/contact" class="page-link">{{
              $t('footer.contactColumn.customerSupport')
            }}</router-link>
            <a href="#" @click.prevent="openContactModal" class="page-link">{{
              $t('footer.contactColumn.contactForm')
            }}</a>
          </div>
        </div>

        <div class="column">
          <img class="icon vespa-icon" src="../../assets/images/delivery_dining.svg" />
          <div class="info-container">
            <h3>{{ $t('footer.workForUsColumn.workForUs') }}</h3>
            <a href="https://recruitment.skroutzdelivery.gr/" target="_blank" class="recruitment">{{
              $t('footer.workForUsColumn.joinOurTeam')
            }}</a>
          </div>
        </div>
      </div>

      <div class="copyright">
        <p>
          <span>
            &copy; 20[0-9]{2} Skroutz A.E. All Rights and Lefts reserved.
          </span>
        </p>
      </div>
    </div>

    <!-- Contact Modal -->
    <CommunicationFormModal
      :show="isContactModalOpen"
      @close="isContactModalOpen = false"
      :submitForm="submitContactForm"
      :formType="'contact'"
    />
    <!-- Toast notifications for footer contact form -->
    <Toast v-if="showToast" :message="toastMessage" :success="toastSuccess" @close="closeToast" />
  </footer>
</template>

<script>
import CommunicationFormModal from './CommunicationFormModal.vue';
import Toast from '../graphic/Toast.vue';
import axios from 'axios';

export default {
  name: 'Footer',
  components: {
    CommunicationFormModal,
    Toast,
  },
  data() {
    return {
      isContactModalOpen: false,
      isLoading: false,
      showToast: false,
      toastMessage: '',
      toastSuccess: false,
    };
  },
  computed: {
    countryCode() {
      return process.env.VUE_APP_COUNTRY_CODE;
    },
  },
  methods: {
    openContactModal() {
      this.isContactModalOpen = true;
    },
    closeToast() {
      this.showToast = false;
    },
    async submitContactForm(name, email, phone, voucher, formMessage, formType) {
      this.isLoading = true;

      const payload = {
        name: name,
        email: email,
        phone: phone,
        voucher: voucher,
        formMessage: formMessage,
        type: formType,
      };

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_COURIER_API}/user/communicationForm`,
          payload,
        );
        if (response.status === 200) {
          // Show success toast
          this.toastMessage = this.$t('footer.toastMessages.submitSuccess');
          this.toastSuccess = true;
          this.showToast = true;
          // Close the modal on success
          this.isContactModalOpen = false;
        }
        return true;
      } catch (err) {
        // Show error toast
        if (err.response?.data?.message) {
          this.toastMessage = err.response.data.message;
        } else {
          this.toastMessage = this.$t('footer.toastMessages.submitFailure');
        }
        this.toastSuccess = false;
        this.showToast = true;
        return false;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.footer-img > a {
  border: unset !important;
}
footer .column .vespa-icon {
  display: none;
}

footer .column .recruitment {
  width: fit-content;
  display: block;
}
.page-link {
  display: block;
  width: fit-content;
}

.contact-form-btn {
  margin-top: 8px;
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.contact-form-btn:hover {
  background-color: #0056b3;
}

@media screen and (max-width: 733px) {
  footer .column:nth-last-child(2) {
    margin-top: 24px !important;
  }
  footer .info-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
  }
  footer .info-container .xyk {
    width: fit-content;
  }
  footer .info-container span {
    width: 100%;
    word-wrap: break-word;
  }
}

@media screen and (min-width: 734px) and (max-width: 960px) {
  footer .column {
    width: 224px;
  }
  footer .info-container {
    width: 225px;
  }
}

@media screen and (min-width: 961px) {
  footer .top-section {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }
  footer .column {
    display: flex;
    flex-grow: 1;
    margin-top: 0 !important;
  }
  footer .copyright {
    text-align: unset !important;
  }
}
@media screen and (min-width: 1424px) {
  footer .column .vespa-icon {
    display: block;
    transform: translateX(40px);
  }
}
</style>
